import Vue from 'vue'
import { Button } from 'element-ui'
import { Card } from 'element-ui'
import { Select } from 'element-ui'
import { Option } from 'element-ui'

Vue.use(Option);
Vue.use(Select);
Vue.use(Button);
Vue.use(Card);